import reducer from './reducers'

export { default as dataTrackingSelectors } from './selectors'
export { default as dataTrackingOperations } from './operations'

export default reducer
